export const API_GRAY_HEADER = "X-API-GRAY"

let getIsGray: (() => boolean | undefined) | undefined

export function injectApiGrayHeaderDeps(deps: {
  getIsGray?: () => boolean | undefined
}) {
  if ("getIsGray" in deps) {
    getIsGray = deps.getIsGray
  }
}

function hasApiGrayHeader(headers: Headers | Record<string, unknown>) {
  if (typeof (headers as Headers).has === "function") {
    return (headers as Headers).has(API_GRAY_HEADER)
  }

  return API_GRAY_HEADER in headers || API_GRAY_HEADER.toLowerCase() in headers
}

export function appendApiGrayHeader(
  headers: Headers | Record<string, unknown> | undefined,
  overrideIsGray?: boolean,
) {
  if (headers && hasApiGrayHeader(headers)) {
    return
  }

  const isGray = overrideIsGray ?? getIsGray?.()
  if (!headers || isGray === undefined) {
    return
  }

  const headerValue = String(isGray)
  if (typeof (headers as Headers).set === "function") {
    ;(headers as Headers).set(API_GRAY_HEADER, headerValue)
    return
  }

  ;(headers as Record<string, string>)[API_GRAY_HEADER] = headerValue
}
